<template>
    <div>
        <b-badge
            :variant="$store.getters['form/status2variant'](model.status)"
            >
            {{
            trans.labels[
            'forms.status.' + model.status
            ]
            }}
        </b-badge>
        <b-badge
            :variant="$store.getters['form/is_public2variant'](model.is_public)"
            >
            {{
            trans.labels[
            'forms.is_public.' + model.is_public
            ]
            }}
        </b-badge>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters([
            'trans',
        ])
    },
    async mounted() {},
    methods: {
        getValueByKey(value, key) {
            let arr
            try {
                arr = JSON.parse(value)
            } catch (e) {}
            if (typeof arr !== 'object') {
                return value
            }
            return Array.isArray(arr[key]) ? arr[key].join('\n') : arr[key] || ''
        },
    },
}
</script>

<style lang="scss" scoped></style>

